import { useCallback, useReducer } from "react";
import { getCreditBalance } from "../api/credithistory.api";
import { creditHistoryInitialState, creditHistoryReducer, getBalanceReducer, totalBalanceState } from "./creditHistory.reduser";


export const useCreditBalanceViewModel = () => {
    const [balanceState, balanceDispatch] = useReducer(getBalanceReducer, totalBalanceState);

    const fetchBalance = useCallback(async () => {
        try {
            console.log("Fetching balance...");
            const response = await getCreditBalance();
            return response.data; // Return the balance value
        } catch (error) {
            return null;
        }
    }, []);
    return {
        balanceState,
        balanceDispatch,
        fetchBalance,
    };
};